var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18,
    stroke: "#9094A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10L16 28M28 14.8L28 23.2C28 24.8802 28 25.7202 27.673 26.362C27.3854 26.9265 26.9265 27.3854 26.362 27.673C25.7202 28 24.8802 28 23.2 28L14.8 28C13.1198 28 12.2798 28 11.638 27.673C11.0735 27.3854 10.6146 26.9265 10.327 26.362C10 25.7202 10 24.8802 10 23.2L10 14.8C10 13.1198 10 12.2798 10.327 11.638C10.6146 11.0735 11.0735 10.6146 11.638 10.327C12.2798 10 13.1198 10 14.8 10L23.2 10C24.8802 10 25.7202 10 26.362 10.327C26.9265 10.6146 27.3854 11.0735 27.673 11.638C28 12.2798 28 13.1198 28 14.8Z",
    stroke: "#626262",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.5bd0ffef185868eec77a437d72f5a101.svg";
export { ForwardRef as ReactComponent };